import { currentThemeAtom } from '@/app/store/theme.ts'
import { useAuth } from '@/hooks/use-auth.ts'
import * as Sentry from '@sentry/react'
import { QueryClient } from '@tanstack/react-query'
import { HeadContent, Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { useAtomValue } from 'jotai'
import { useEffect } from 'react'

export interface RootContext {
  queryClient: QueryClient
  auth: ReturnType<typeof useAuth>
}

export const Route = createRootRouteWithContext<RootContext>()({
  component: RootComponent,
  errorComponent: (error) => {
    useEffect(() => {
      Sentry.captureException(error)
    }, [])

    return (
      <div>
        <h1>Houve um erro</h1>
        <code>{JSON.stringify(error.info)}</code>
      </div>
    )
  },
})

function RootComponent() {
  const theme = useAtomValue(currentThemeAtom)

  useEffect(() => {
    const root = window.document.documentElement

    root.classList.toggle('dark', theme === 'dark')
    root.classList.toggle('light', theme === 'light')
  }, [theme])

  return (
    <>
      <HeadContent />
      <Outlet />
      <TanStackRouterDevtools />
    </>
  )
}
